import './App.css';
import AppRoutes from './AppRoutes';
import Auth0AxiosBridge from "./Auth0AxiosBridge";


function App() {
  return (
    <div className="App">
          <Auth0AxiosBridge />
          <AppRoutes />
    </div>
  );
}

export default App;

